import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGtag from "vue-gtag";
import App from './App.vue'
import store from "./store"
import VueSweetalert2 from 'vue-sweetalert2';
import "skeleton-screen-css"
import axios from "axios";

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'

// router setup
import routes from './routes/routes'

// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)
Vue.use(VueSweetalert2);

Vue.prototype.$eventHub = new Vue();

if(process.env.NODE_ENV === 'production') { // 'development'|'test'|'production'
  //let oldLog = console.log
  //console.log = function (message) { oldLog("Log -> " + message)}
  console.log = function (message) {}
}


axios.interceptors.request.use(
  function (config) {
    let session = JSON.parse(localStorage.getItem("session"))
    if (session) config.headers['Authorization'] = 'Bearer ' + session.access_token
    return config
  },
  function (error) {
    console.log(error);
    this.logoutEGI()
    return Promise.reject(error.response)
  }
)


// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  // Remove obsolete '/#/' path from hash mode and '/auth/' path from authenticated sections

  let normalizedFullPath = to.fullPath.replace('/#/','/').replace('/auth/','/')
  if(to.fullPath !== normalizedFullPath) next(normalizedFullPath)
  else next()

});

Vue.use(VueGtag, {
  config: { id: 'G-NN2TNNYRDB' }
  }, router
);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
})
